// Phase 36 Batch T — UTM capture util.
//
// On the very first landing-page visit we read utm_source / utm_medium /
// utm_campaign from the URL and stash them in sessionStorage. Later
// the signup form reads them back and sends them to the backend so
// the signup event in `user_events` carries the attribution.
//
// We use sessionStorage (NOT localStorage) so two simultaneous tabs
// from different campaigns don't fight each other.

const KEY = "runidea.utm.v1";

const UTM_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function captureUTMFromLocation() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  for (const k of UTM_FIELDS) {
    const v = params.get(k);
    if (v) utm[k] = v;
  }
  if (Object.keys(utm).length === 0) return;
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({
      ...utm,
      captured_at: new Date().toISOString(),
      landing_referrer: document.referrer || null,
    }));
  } catch {
    // Storage may be unavailable (incognito + restricted) — silent skip.
  }
}

export function readStashedUTM() {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return {};
    const obj = JSON.parse(raw);
    // Only expose the UTM fields, never the audit metadata.
    const out = {};
    for (const k of UTM_FIELDS) {
      if (obj[k]) out[k] = obj[k];
    }
    return out;
  } catch {
    return {};
  }
}

export function clearStashedUTM() {
  if (typeof window === "undefined") return;
  try { window.sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
